import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { popupAuthGuard } from './core/guards/popup-auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    // Do not redirect to not-found, as this will cause problems with login
    path: '',
    component: LayoutComponent,
  },
  {
    path: 'ansokningsomgang/:diarienummer',
    component: LayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/ansokningsomgang/ansokningsomgang.component').then(
            (m) => m.AnsokningsomgangComponent,
          ),
      },
    ],
  },
  {
    path: 'ansokningsomgang/:diarienummer/effekta',
    component: LayoutComponent,
    // För att redirects inte fungerar i iframe så används popup.
    canActivate: [popupAuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/ansokningsomgang/ansokningsomgang.component').then(
            (m) => m.AnsokningsomgangComponent,
          ),
        data: { isEffekta: true },
      },
    ],
  },
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: 'not-found',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
